import React, { useContext, useEffect, useState } from "react";
import { MaterialReactTable } from "material-react-table";
import { User2Icon } from "lucide-react";
import { base_url } from "../../config";
import axios from "axios";
import RegistrationContext from "../../contexts/RegistrationContext";

const typeFilters = [
  { label: "All", value: "" },
  { label: "Industry", value: "industry" },
  { label: "Regular", value: "regular" },
  { label: "Student", value: "student" },
  { label: "Student Paper", value: "student-paper" },
];

const statusFilters = [
  { label: "All", value: "" },
  { label: "Completed", value: "Completed" },
  { label: "In progress", value: "In progress" },
];

const Papers = () => {
  const [data, setData] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [typeFilter, setTypeFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState("");

  const [validatedFilter, setValidatedFilter] = useState("");

  useEffect(() => {
    axios
      .get(`${base_url}/api/admin/papers`)
      .then((response) => setData(response.data.papers))
      .catch((error) => console.error("Error fetching students:", error));
  }, []);

  const filteredData = data.filter((row) => {

    const validatedMatch = validatedFilter
      ? validatedFilter === "OK"
        ? row.validated === 1
        : validatedFilter === "Pending"
          ? row.validated === 0
          : validatedFilter === "Rejected"
            ? row.validated === -1
            : validatedFilter === "Not Registered"
              ? row.validated === 2
              : true
      : true;

    return validatedMatch;
  });

  const columns = [

    {
      accessorKey: "paper_id",
      header: "ID",
      size: 50, // Set column width to 50px
      Cell: ({ cell }) => (
        <div className="border border-gray-200 text-gray-800 text-sm font-medium px-2 py-1 rounded-lg text-center">
          {cell.getValue()}
        </div>
      ),
    },
    { accessorKey: "track", header: "Track" },
    { accessorKey: "title", header: "Title" },
    { accessorKey: "registrations", header: "Registrations" },
    {
      accessorKey: "validated",
      header: "Validations",
      Cell: ({ cell }) => {
        const value = cell.getValue();
        let status = "";
        let color = "";
    
        if (value === 2) {
          status = "Not Registered";
          color = "bg-purple-100 text-purple-800 border-purple-300 w-40";
        } else 
        if (value === 1) {
          status = "OK";
          color = "bg-green-100 text-green-800 border-green-300 w-20";
        } else if (value === 0) {
          status = "Pending";
          color = "bg-blue-100 text-blue-800 border-blue-300 w-20";
        } else if (value === -1) {
          status = "Rejected";
          color = "bg-red-100 text-red-800 border-red-300 w-20";
        }
    
        return (
          <div
            className={`px-3 py-1 rounded border text-sm font-semibold text-center ${color}`}
          >
            {status}
          </div>
        );
      },
    }
  ];


  return (
    <>
      <div className="text-2xl mt-4 pb-4 font-bold flex gap-8 items-center">
        <User2Icon />
        Papers
      </div>

      {/* Filters */}
      <div className="flex flex-col gap-4 mb-4">
        {/* Filter by Validation */}
        <div className="flex items-center gap-2">
          <span className="text-sm font-bold text-gray-700">Filter by Validation:</span>
          {[
            { label: "All", value: "" },
            { label: "OK", value: "OK", color: "bg-green-100 text-green-800 border-green-300" },
            { label: "Pending", value: "Pending", color: "bg-blue-100 text-blue-800 border-blue-300" },
            { label: "Rejected", value: "Rejected", color: "bg-red-100 text-red-800 border-red-300" },
            { label: "Not Registered", value: "Not Registered", color: "bg-purple-100 text-purple-800 border-purple-300" }
          ].map((filter) => {
            const isActive = validatedFilter === filter.value;
            return (
              <button
                key={filter.value}
                className={`px-3 py-1 rounded border text-sm font-semibold transition-colors
            ${filter.color || "bg-white text-gray-700 border-gray-300"}
            ${isActive ? "ring-2 ring-blue-400" : ""}
          `}
                onClick={() => setValidatedFilter(filter.value)}
              >
                {filter.label}
              </button>
            );
          })}
        </div>
      </div>

      <div style={{ flex: "1 1 0", paddingBottom: "20px" }}>
        <MaterialReactTable columns={columns} data={filteredData} />
      </div>
    </>
  );
};

export default Papers;
